<template>
  <div id="sneosContactButtonApp">
    <label for="modal_c" class="button pseudo">Contact us</label>

    <div class="modal" v-bind:class="isModalOpen ? 'modal-open': 'modal-closed'">
      <input id="modal_c" type="checkbox" v-on:change="modalChange($event)" />
      <label for="modal_c" class="overlay" v-on:click="hideModal($event)"></label>

      <contact-button></contact-button>
    </div>
  </div>
</template>

<style type="text/scss" lang="scss">
sneos-contact-button {
  @import "../node_modules/picnic/src/picnic.scss";

  #sneosContactButtonApp {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-weight: 300;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #a61111;
    margin-top: 60px;

    left: 0;
    top: 45%;
    position: fixed;
    z-index: 11;
    background: white;
    border: 1px solid gray;
    max-width: 450px;
  }
  nav {
    position: relative;
  }
  .hello {
    text-align: center;
  }

  .brand {
    font: 16px/18px "MuseoSlab500Regular", arial, helvetica, sans-serif;
  }

  @media all and (min-width: 1em) {
    .vertical-menu {
      height: 99vh;
    }
    nav .show:checked ~ .menu > *:nth-child(1) {
      -webkit-transition: all 0.5s cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
      transition: all 0.5s cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    }

    nav .show:checked ~ .menu > * {
      -webkit-transform: translateX(0);
      transform: translateX(0);
      -webkit-transition: all 0.5s ease-in-out 0.6s;
      transition: all 0.5s ease-in-out 0.6s;
    }

    nav .burger ~ .menu > * {
      display: block;
      margin: 0;
      text-align: left;
      max-width: 100%;
    }
    nav .burger ~ .menu {
      z-index: 999;
    }

    nav .burger ~ .menu,
    nav .show:checked ~ .burger {
      position: fixed;
      min-height: 100%;
      top: 0;
      right: 0;
      bottom: -1000em;
      margin: 0;
      background: #fff;
      -webkit-transition: all 0.5s ease;
      transition: all 0.5s ease;
      -webkit-transform: none;
      transform: none;
    }
    nav .burger {
      display: inline-block;
      cursor: pointer;
      bottom: -1000em;
      margin: 0;
    }
    nav .burger ~ .menu,
    nav .show:checked ~ .burger {
      position: fixed;
      min-height: 100%;
      top: 0;
      right: 0;
      bottom: -1000em;
      margin: 0;
      background: #fff;
      -webkit-transition: all 0.5s ease;
      transition: all 0.5s ease;
      -webkit-transform: none;
      transform: none;
    }

    nav .show:checked ~ .burger {
      color: transparent;
      width: 100%;
      border-radius: 0;
      background: rgba(0, 0, 0, 0.2);
      -webkit-transition: all 0.5s ease;
      transition: all 0.5s ease;
    }
    nav .show:checked ~ .menu {
      -webkit-transform: scaleX(1);
      transform: scaleX(1);
    }
    nav .show ~ .menu {
      width: 90%;
      max-width: 300px;
      -webkit-transform-origin: center right;
      transform-origin: center right;
      -webkit-transition: all 0.25s ease;
      transition: all 0.25s ease;
      -webkit-transform: scaleX(0);
      transform: scaleX(0);
    }

    .modal.modal-closed {
      display: none;
    }
    .modal.modal-open {
      display: block;
    }
    .modal .overlay ~ * {
      min-width: 99%;
    }

    .modal .overlay ~ * section {
      padding: 1px 1px;
    }
  }

  input[type="radio"]:checked + label {
    color: white;
    font-style: normal;
  }
  label.stack .button {
    background: #e7eaed94;
  }

  @media all and (min-width: 800px) {
    .modal .overlay ~ * {
      min-width: 60%;
    }
    .vertical-menu {
      height: 95vh;
    }
  }
  @media all and (min-width: 1000px) {
    .modal .overlay ~ * {
      min-width: 75%;
    }
    .vertical-menu {
      height: 95vh;
    }
  }
  @media all and (min-width: 1200px) {
    .modal .overlay ~ * {
      min-width: 50%;
    }
    .vertical-menu {
      height: 80vh;
    }
  }
  @media all and (min-width: 1800px) {
    .modal .overlay ~ * {
      min-width: 40%;
    }
    .vertical-menu {
      height: 85vh;
    }
  }
  @media all and (min-width: 2000px) {
    .modal .overlay ~ * {
      min-width: 30%;
    }
    .vertical-menu {
      height: 80vh;
    }
  }
}
</style>
 
<script>
import ContactButton from "./components/ContactUsApp/ContactButton";

export default {
  name: "contactApp",
  components: {
    ContactButton,
  },
  data: function () {
    return {
      isSidebarOpen: false,
      resource: {},

      isModalOpen: false,
    };
  },
  methods: {
    modalChange: function (event) {
      this.isModalOpen = event.target.checked;
      console.log("modalChange:" + this.isModalOpen);
    },
    hideModal: function (e) {
      if (this.isSidebarOpen) {
        e.preventDefault();
        e.stopPropagation();

        // close sidebar

        this.isSidebarOpen = false;
      }
    },
  },
};
</script>